import Vue from 'vue'
import Vuex from 'vuex'
import { fetchPrice } from './api'
Vue.use(Vuex)

const store = new Vuex.Store({
  strict: false,
  state: {
    order: {
      currency: 'CHF',
      quantity: 1,
      price: 0,
      shipping: 0,
      shipping_total: 0,
      package: 0.0,
      paypal_total: 0.0,
      paypal_fee: 0.0,
      form: '',
      first_name: '',
      last_name: '',
      street: '',
      zip: '',
      city: '',
      email: '',
      payment: 'bank',
      payment_items: [],
      country: 'ch',
      min_quantity: 1,
      max_quantity: 1,
      forced_currency: '',
      country_help: ''
    }
  },

  actions: {
    FETCH_PRICE: ({ commit, state }, {quantity}) => {
      return fetchPrice(quantity,state.order.country,state.order.currency)
      .then(
        price => {
          commit('SET_PRICE', { price })
        }
      )
    }
  },

  mutations: {
    SET_PRICE: (state, { price }) => {
      if (price) {
        const prices = price.prices;
        var o = state.order;
        //o = Object.assign(o, prices)
        o.quantity = prices.quantity;
        o.package = prices.package;
        o.price = prices.product;
        o.shipping = prices.shipping;
        o.shipping_total = prices.shipping_total;
        o.paypal_total = prices.paypal_total;
        o.paypal_fee = prices.paypal_fee;
        o.min_quantity = prices.min_quantity;
        o.max_quantity = prices.max_quantity;
        if(o.forced_currency !== "" && (o.forced_currency==="CHF" || o.forced_currency==="EUR" )) {
          o.currency = o.forced_currency;
        }
        else {
          o.currency = prices.currency;
        }

        o.payment_items = prices.payment_systems.map(function(v) {
          var item = {value: v, text: ""};
          switch(v) {
            case "paypal": 
              item.text = "Kreditkarte / Paypal";
              break;
            case "bank": 
              item.text = "Banküberweisung";
              break;            
          }
          return item;
        });

        if(prices.payment_systems.indexOf(o.payment) == -1) {
          o.payment = prices.payment_systems[0];
        }

        if(o.country !== "ch") {
          o.country_help = "Zoll- oder Einfuhrgebühren werden erhoben, sobald das Paket Ihr Land erreicht hat. Gebühren für die Zollfreigabe gehen zu Ihren Lasten. Wir haben keinen Einfluss auf diese Gebühren und können ihre Höhe nicht vorhersagen. Die Zollbestimmungen variieren von Land zu Land beträchtlich. Für weitere Informationen kontaktieren Sie bitte Ihre Zollbehörden vor Ort."
        }
        else {
          o.country_help = ""
        }
      }
    },
    SET_COUNTRY: (state, {country_items, country, forced_currency }) => {
      var o = state.order;
      o.country_items = country_items,
      o.country = country
      if(forced_currency) {
        o.forced_currency = forced_currency
      } 
    }
  },

  getters: {
  }
})

export default store


// WEBPACK FOOTER //
// ./lib/store/index.js